/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningsemptyevents2Inputs */

const en_earningsemptyevents2 = /** @type {(inputs: Earningsemptyevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to your events`)
};

const de_earningsemptyevents2 = /** @type {(inputs: Earningsemptyevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu deinen Events`)
};

/**
* | output |
* | --- |
* | "Go to your events" |
*
* @param {Earningsemptyevents2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsemptyevents2 = /** @type {((inputs?: Earningsemptyevents2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsemptyevents2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsemptyevents2(inputs)
	return de_earningsemptyevents2(inputs)
});
export { earningsemptyevents2 as "earningsEmptyEvents" }